<template>
  <div class="el-tabs-container">
    <el-tabs v-model="tab_index">
      <el-tab-pane label="信用额度维护">
        <span slot="label">{{ $t("tab.tab_customer_credit") }}</span>
        <SplitContainer2 style="height:100%" :split_setting="0.55" layout="horizontal">
          <template #table1>
            <TableMain name="one table" ref="creditTable" :fields="fields" :title="table_title.title1"
              :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
              :show_date_picker="false" :show_toolbar="true" :show_filter="true" :date_picker_label="date_picker_label"
              :query_button_label="query_lable" :isBusy="isBusy" @on_query="on_query" @state_change="state_change"
              :show_toolbar_button="[0, 0, 1, 1, 0]" :hb_table_class="'hb_table_cust_credit_class1'"
              @current_changed="current_changed" @on_cell_button_click="on_cell_button_click">
              <template #query>
                {{ $t("common.customer") + $t("common.account") }}：<el-input clearable size="small" style="width: 120px"
                  v-model="customer_name">
                </el-input>
              </template>
              <template #toolbar>
                <el-checkbox :label="$t('common.show_all')" v-model="isAll" class="ml-2"
                  @change="showAll"></el-checkbox>
                <el-checkbox :label="$t('common.my_approval')" v-model="onlyMyApproved" class="ml-2"
                  @change="myApproveChange"></el-checkbox>
              </template>
            </TableMain>
          </template>
          <template #table2>
            <BaseContainer style="height:100%" class="one_table">
              <TableMain name="TempCreditTable" :fields="tempfields" :title="table_title.title2"
                @state_change="state_temp_change" :show_query_container="false" :show_toolbar="true" :isBusy="isBusy1"
                :show_toolbar_button="[0, 0, 1, 1, 1]" ref="TempCreditTable" @on_cell_button_click="edit_temp_credit">
                <template #toolbar="">
                  <el-button type="info" plain @click="createTempForm('new')" style="width: 55px"
                    class="ml-2 iconfont icon-add-new" size="mini">
                  </el-button>
                  <el-checkbox :label="$t('common.my_approval')" v-model="onlyMyTempApproved" class="ml-2"
                    @change="myTempApproveChange">
                  </el-checkbox>
                </template>
              </TableMain>
            </BaseContainer>
          </template>
        </SplitContainer2>
      </el-tab-pane>
      <el-tab-pane label="信用额度查询">
        <span slot="label">{{ $t("tab.tab_customer_credit_search") }}</span>
        <CustomerCreditSearch></CustomerCreditSearch>
      </el-tab-pane>
      <el-tab-pane label="信用额度日志">
        <span slot="label">{{ $t("tab.tab_customer_credit_log") }}</span>
        <CustomerCreditLog></CustomerCreditLog>
      </el-tab-pane>
    </el-tabs>

    <!-- 新增修改 -->
    <BaseModal ref="bvModal" :title="modal_title" @saveData="saveData" :size="'md'">
      <template #modal_content>
        <el-form :model="dataForm" :rules="rules" ref="dataForm" label-width="100px" class="demo-dataForm">
          <el-form-item :label="$t('common.customer')">
            <span><strong class="text-danger">{{
              dataForm.AccountNum
                }}</strong></span>
          </el-form-item>
          <el-form-item :label="$t('common.customer_credit')">
            <el-input v-model="dataForm.CreditMax" type="number"></el-input>
          </el-form-item>
          <el-form-item :label="$t('common.create_date')">
            <el-col :span="10">
              <el-date-picker v-model="dataForm.FromDate" style="width: 100%" type="date"
                :placeholder="$t('common.select_date')">
              </el-date-picker>
            </el-col>
            <el-col class="line text-right pr-3" :span="4">{{ $t("common.end_date") }}</el-col>
            <el-col :span="10">
              <el-date-picker v-model="dataForm.ToDate" style="width: 100%" type="date"
                :placeholder="$t('common.select_date')">
              </el-date-picker>
            </el-col>
          </el-form-item>
          <el-form-item :label="$t('common.description')">
            <el-input type="textarea" v-model="dataForm.description"></el-input>
          </el-form-item>
        </el-form>
      </template>
    </BaseModal>
    <BaseModal ref="bvTempModal" :title="modal_title1" @saveData="saveTempData" :size="'md'">
      <template #modal_content>
        <el-form :model="dataForm1" :rules="rules1" ref="dataForm1" label-width="100px" class="demo-dataForm">
          <el-form-item :label="$t('common.customer_credit_temp')" prop="CreditMax">
            <el-input v-model="dataForm1.CreditMax" type="number"></el-input>
          </el-form-item>
          <el-form-item :label="$t('common.create_date')">
            <el-col :span="10">
              <el-date-picker v-model="dataForm1.FromDate" style="width: 100%" type="date"
                :placeholder="$t('common.select_date')">
              </el-date-picker>
            </el-col>
            <el-col class="line text-right pr-3" :span="4">{{ $t("common.end_date") }}</el-col>
            <el-col :span="10">
              <el-date-picker v-model="dataForm1.ToDate" style="width: 100%" type="date"
                :placeholder="$t('common.select_date')">
              </el-date-picker>
            </el-col>
          </el-form-item>
          <el-form-item :label="$t('common.description')" prop="description">
            <el-input type="textarea" v-model="dataForm1.description"></el-input>
          </el-form-item>
        </el-form>
      </template>
    </BaseModal>
  </div>
</template>

<script>
import * as commonController from "../../controllers/commonController"
import * as CustomerCreditController from "../../controllers/fi/CustomerCreditController"
import * as SalesOrderController from "../../controllers/sd/SalesOrderController"
import * as api from "../../shared/api"
import apiPath from "../../shared/apiPath"
import BaseContainer from "../components/BaseContainer"
import SplitContainer2 from "../components/container/SplitContainer2"
import BaseModal from "../components/modals/baseModal"
import TableMain from "../components/table/TableMain"
import CustomerCreditLog from "./CustomerCreditLog"
import CustomerCreditSearch from "./CustomerCreditSearch"

export default {
  name: "CustTable",
  components: {
    BaseContainer,
    TableMain,
    BaseModal,
    SplitContainer2,
    CustomerCreditSearch,
    CustomerCreditLog,
  },
  data() {
    return {
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_customer_credit",
        title2: "table_customer_credit_temp",
      },
      modal_title: "create_cust_credit",
      modal_title1: "create_cust_temp_credit",
      fields: CustomerCreditController.fields.default,
      tempfields: CustomerCreditController.fields.detail_fields,
      dataForm: _.cloneDeep(CustomerCreditController.dataForm),
      dataForm1: _.cloneDeep(CustomerCreditController.dataForm1),
      rules: CustomerCreditController.rules,
      rules1: CustomerCreditController.rules1,
      customer_name: "",
      isBusy: false,
      isBusy1: false,
      selectedItem: null,
      currentCreditSet: null,
      tab_index: 0,
      onlyMyApproved: false,
      onlyMyTempApproved: false,
      all_role_users: [],
      his_credit_list: [],
      his_temp_credit_list: [],
      isAll: false,
    }
  },
  async created() {
    await this.getAllRoleUsers()
  },
  methods: {
    async getAllRoleUsers() {
      let _result = await SalesOrderController.methods.getAllRoleUserName()
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.all_role_users = _result[0]
      }
    },
    //#region  信用额度
    //查询
    async on_query(set_data) {
      this.isAll = false
      this.onlyMyApproved = false
      this.onlyMyTempApproved = false
      this.$refs.TempCreditTable.SetData([])
      this.isBusy = true
      set_data([])
      let _result = await CustomerCreditController.methods.getData({
        id: { ">": 0 },
        SEI_Name: { like: "%" + this.customer_name + "%" },
      })
      if (!_.isNull(_result) && _result && _result.length > 0) {
        _.each(_result, (t) => {
          commonController.methods.getUserNameFromRole(
            this.all_role_users,
            t,
            "fcGetCustomerCreditApprover",
            "CustomerCreditApprover"
          )
        })
        this.his_credit_list = _.cloneDeep(_result)
        let _list = _.filter(_result, function (t) {
          return t.credit_Id != ""
        })
        set_data(_.orderBy(_list, ["id"], ["asc"]))
      }
      this.isBusy = false
    },
    showAll() {
      this.onlyMyApproved = false
      if (this.isAll) {
        this.$refs.creditTable.SetData(this.his_credit_list)
      } else {
        let _list = _.filter(this.his_credit_list, function (t) {
          return t.credit_Id != ""
        })
        this.$refs.creditTable.SetData(_list)
      }
    },

    //状态切换
    async state_change(data, cb) {
      if (data.selected_items.length == 0) {
        this.msgToasts(this.$t("notify.not_selected_data"), "info")
        cb(false)
        return
      }
      let _check_has_credit = []
      _.each(data.selected_items, (t) => {
        if (t.credit_Id == "") {
          if (_check_has_credit.length <= 5) {
            _check_has_credit.push(t.AccountNum)
          }
          if (_check_has_credit.length == 5) {
            _check_has_credit.push("......")
          }
        }
      })
      if (_check_has_credit.length > 0) {
        this.msgToasts(this.$t("common.provider") + this.$t("common.num") + "：" + _.join(_check_has_credit, "，") + "，" + this.$t("notify.not_customer_credit"), "info")
        return
      }
      ///检查是否有该权限
      let _selected_list = this.$refs.creditTable.GetSelectedItems()
      let _check_list = await this.checkApproveStatus(
        "CustomerCredit",
        _selected_list
      )
      if (_check_list.length > 0) {
        this.msgToasts(this.$t("notify.not_privileges") + "（" + _.join(_check_list, "，") + "）", "error")
        cb(false)
        return
      }

      let _roles = []
      if (this.$store.state.biz_data.userInfo.user_roles_privileges.roles) {
        _roles = _.map(
          this.$store.state.biz_data.userInfo.user_roles_privileges.roles,
          "code"
        )
      }
      let _list = _.cloneDeep(data.selected_items)
      let _update_status_list = []
      for (var i in _list) {
        let _as_result = await SalesOrderController.methods.getApproveStatus({
          DocumentType: "CustomerCredit",
          ApproveType: "",
          ItemId: _list[i].credit_Id,
        })
        _.each(_as_result[0], (at) => {
          if (
            _.includes(_roles, at.Approver) ||
            this.$global.global_data.local_username == at.Approver
          ) {
            _list[i].status_id = at.id
            _update_status_list.push(at)
          }
        })
      }
      this.msgModal(this.$t("notify.is_continue")).then(async (v) => {
        if (v) {
          let _state_data = _.cloneDeep(data)
          _state_data.selected_items = _list
          let _b = await CustomerCreditController.methods.changeState(
            _state_data
          )
          if (_b) {
            _.each(data.selected_items, (t) => {
              t.is_approved = data.state == "approved" ? true : false
              let _ap_list = _.find(_update_status_list, {
                ItemId: t.credit_Id,
              })
              if (_update_status_list && data.state != "approved") {
                if (this.all_role_users.length > 0) {
                  let _rn_data = []
                  _.each(this.all_role_users, (d) => {
                    if (d.role_code == _ap_list.Approver) {
                      _rn_data.push(d.username)
                    } else {
                      t.CustomerCreditApprover = _ap_list.Approver
                    }
                  })
                  if (_rn_data && _rn_data.length > 0) {
                    t.CustomerCreditApprover = _rn_data.join("，")
                  }
                }
              } else {
                t.CustomerCreditApprover = ""
              }
            })
            this.msgToasts(this.$t("notify.action_successfully"), "success")
            cb(true)
          } else {
            this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
            cb(false)
          }
        }
      })
    },
    ///检查是否包含该审批权限
    async checkApproveStatus(code, _selected_list) {
      let _check_list = []
      let _roles = []

      if (this.$store.state.biz_data.userInfo.user_roles_privileges.roles) {
        _roles = _.map(
          this.$store.state.biz_data.userInfo.user_roles_privileges.roles,
          "code"
        )
      }

      for (var i in _selected_list) {
        let t = _selected_list[i]
        let _as_result = await SalesOrderController.methods.getApproveStatus({
          DocumentType: code,
          ApproveType: "",
          ItemId: code == "CustomerCredit" ? t.credit_Id : t.id,
        })
        let _is_ok = true
        for (var j in _as_result[0]) {
          let at = _as_result[0][j]
          if (at) {
            if (
              _.includes(_roles, at.Approver) ||
              this.$global.global_data.local_username == at.Approver
            ) {
              _is_ok = false
            }
          }
        }
        if (_is_ok && !_.includes(_check_list, t.id)) {
          _check_list.push(t.id)
        }
      }
      return _check_list
    },
    ///设置信用额度
    on_cell_button_click(data) {
      this.currentCreditSet = data.item
      if (data.item.credit_Id != "") {
        this.dataForm.id = data.item.credit_Id
        this.dataForm.AccountNum = data.item.AccountNum
        this.dataForm.CreditMax = data.item.CreditMax
        this.dataForm.description = data.item.description
        this.dataForm.FromDate = data.item.FromDate
        this.dataForm.ToDate = data.item.ToDate
        this.createForm("edit")
      } else {
        this.dataForm = _.cloneDeep(CustomerCreditController.dataForm)
        this.dataForm.id = ""
        this.dataForm.AccountNum = data.item.AccountNum
        this.createForm("new")
      }
    },
    ///初始化编辑界面
    createForm(code) {
      let title = ""
      switch (code) {
        case "new":
          title = "create_cust_credit"
          break
        case "edit":
          title = "edit_cust_credit"
          break
      }
      this.modal_title = title
      this.$refs.bvModal.show()
    },
    ///新增修改
    saveData(cb) {
      let _this = this
      this.$refs.dataForm.validate(async (valid) => {
        if (valid) {
          let _data = _.cloneDeep(_this.dataForm)
          if (_data.id == "") {
            delete _data.id
          }

          _data.FromDate = this.$date.format(
            new Date(_data.FromDate),
            "yyyy-MM-dd"
          )
          _data.ToDate = this.$date.format(
            new Date(_data.ToDate),
            "yyyy-MM-dd"
          )

          ///保存数据
          let _rel_save_data =
            await CustomerCreditController.methods.saveCredit(_data)
          if (!_.isNull(_rel_save_data)) {
            let _result = await CustomerCreditController.methods.getData({
              id: { "=": this.currentCreditSet.id },
            })

            if (!_.isNull(_result) && _result && _result.length > 0) {
              _.each(_result, (t) => {
                commonController.methods.getUserNameFromRole(
                  this.all_role_users,
                  t,
                  "fcGetCustomerCreditApprover",
                  "CustomerCreditApprover"
                )
              })
              this.$refs.creditTable.UpdateItems(
                { id: this.currentCreditSet.id },
                _result[0]
              )
            }
            // if (!_.isNull(this.currentCreditSet)) {
            //   this.currentCreditSet.CreditMax = _rel_save_data[0][0].CreditMax;
            //   this.currentCreditSet.credit_Id = _rel_save_data[0][0].id;
            //   this.currentCreditSet.description =
            //     _rel_save_data[0][0].description;
            //   this.currentCreditSet.FromDate = _rel_save_data[0][0].FromDate;
            //   this.currentCreditSet.ToDate = _rel_save_data[0][0].ToDate;
            // }
            ///成功
            cb(true, true)
          } else {
            ///失败
            cb(true, false)
          }
        } else {
          cb(false)
          return false
        }
      })
    },
    //#endregion

    //#region  临时信用额度

    //初始化临时额度界面
    createTempForm(code) {
      let _cut_m = this.$refs.creditTable.GetCurrentItem()
      console.log(_cut_m)
      if (!_cut_m) {
        this.msgToasts(this.$t("notify.not_selected_customer"), "warning")
        return
      }
      let title = ""
      switch (code) {
        case "new":
          this.dataForm1 = _.cloneDeep(CustomerCreditController.dataForm1)
          this.dataForm1.AccountNum = _cut_m.AccountNum
          this.dataForm1.CreditMax = 0
          this.dataForm1.FromDate = new Date()
          this.dataForm1.ToDate = new Date("2099-12-31")
          title = "create_cust_temp_credit"
          break
        case "edit":
          title = "edit_cust_temp_credit"
          break
      }
      this.modal_title1 = title
      this.$refs.bvTempModal.show()
    },
    saveTempData(cb) {
      let _this = this
      this.$refs.dataForm1.validate(async (valid) => {
        if (valid) {
          let _data = _.cloneDeep(_this.dataForm1)
          if (_data.FromDate && _.isDate(_data.FromDate)) {
            _data.FromDate = this.$date.format(_data.FromDate, "yyyy-MM-dd")
          }
          if (_data.ToDate && _.isDate(_data.ToDate)) {
            _data.ToDate = this.$date.format(_data.ToDate, "yyyy-MM-dd")
          }
          _data.Credit_Id = 0
          if (_data.id == "") {
            delete _data.id
          }
          ///保存数据
          let _rel_save_data =
            await CustomerCreditController.methods.saveTempCredit(_data)
          if (!_.isNull(_rel_save_data)) {
            if (_data.id) {
              this.$refs.TempCreditTable.UpdateItems(
                { id: _data.id },
                _rel_save_data[0][0]
              )
            } else {
              let _result = await CustomerCreditController.methods.getTempData({
                id: { "=": _rel_save_data[0][0].id },
              })
              console.log(_rel_save_data, _result)
              if (!_.isNull(_result) && _result && _result.length > 0) {
                _.each(_result[0], (t) => {
                  commonController.methods.getUserNameFromRole(
                    this.all_role_users,
                    t,
                    "fcGetCustomerTempCreditApprover",
                    "CustomerTempCreditApprover"
                  )
                })
                this.$refs.TempCreditTable.InsertItems(_result[0][0])
              }
            }
            ///成功
            cb(true, true)
          } else {
            ///失败
            cb(true, false)
          }
        } else {
          cb(false)
          return false
        }
      })
    },
    //编辑临时额度
    edit_temp_credit(data) {
      this.dataForm1.id = data.item.id
      this.dataForm1.CreditMax = data.item.CreditMax
      this.dataForm1.FromDate = data.item.FromDate
      this.dataForm1.ToDate = data.item.ToDate
      this.dataForm1.description = data.item.description
      this.createTempForm("edit")
    },
    current_changed(old, current) {
      this.onlyMyTempApproved = false
      if (_.isNull(current)) {
        return
      }
      this.$emit("current_changed", old, current)
      this.selectedItem = current
      this.getTempData(current)
    },
    async getTempData(data) {
      this.isBusy1 = true
      let _result = await CustomerCreditController.methods.getTempData({
        AccountNum: { "=": data.AccountNum },
      })
      _.each(_result[0], (t) => {
        commonController.methods.getUserNameFromRole(
          this.all_role_users,
          t,
          "fcGetCustomerTempCreditApprover",
          "CustomerTempCreditApprover"
        )
      })
      this.his_temp_credit_list = _result[0]
      this.$refs.TempCreditTable.SetData(
        _.orderBy(_result[0], ["id"], ["desc"])
      )
      this.$refs.TempCreditTable.UnSelectAll()
      this.isBusy1 = false
    },
    async state_temp_change(data, cb) {
      if (data.state === "deleted") {
        let _check_del_list = []
        _.each(data.selected_items, function (t) {
          if (t.is_approved == true) {
            _check_del_list.push(t.id)
          }
        })
        if (_check_del_list.length > 0) {
          this.msgToasts(
            _.toString(_check_del_list) + "，" + this.$t("notify.has_approved")
          )
          return
        }
        this.msgModal(this.$t("notify.is_deleted")).then(async (v) => {
          if (v) {
            let result = await CustomerCreditController.methods.deleteItemData(
              data.selected_items
            )
            if (result) {
              this.msgToasts(this.$t("notify.action_successfully"), "success")
              cb(true)
            } else {
              this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
              cb(false)
            }
          }
        })
      } else if (data.state === "approved" || data.state === "unapproved") {
        ///检查是否有该权限
        let _selected_list = this.$refs.TempCreditTable.GetSelectedItems()
        let _check_list = await this.checkApproveStatus(
          "CustomerTempCredit",
          _selected_list
        )
        if (_check_list.length > 0) {
          this.msgToasts(this.$t("notify.not_privileges") + "（" + _.join(_check_list, "，") + "）", "error")
          cb(false)
          return
        }
        //整理数据
        let _list = _.cloneDeep(data.selected_items)
        let _update_status_list = []

        let _roles = []
        if (this.$store.state.biz_data.userInfo.user_roles_privileges.roles) {
          _roles = _.map(
            this.$store.state.biz_data.userInfo.user_roles_privileges.roles,
            "code"
          )
        }
        for (var i in _list) {
          let _as_result = await SalesOrderController.methods.getApproveStatus({
            DocumentType: "CustomerTempCredit",
            ApproveType: "",
            ItemId: _list[i].id,
          })
          _.each(_as_result[0], (at) => {
            if (
              _.includes(_roles, at.Approver) ||
              this.$global.global_data.local_username == at.Approver
            ) {
              _list[i].status_id = at.id
              _update_status_list.push(at)
            }
          })
        }
        this.msgModal(this.$t("notify.is_continue")).then(async (v) => {
          if (v) {
            let _state_data = _.cloneDeep(data)
            _state_data.selected_items = _list
            let _b = await CustomerCreditController.methods.changeTempState(
              _state_data
            )
            if (_b) {
              _.each(data.selected_items, (t) => {
                t.is_approved = data.state == "approved" ? true : false
                let _ap_list = _.find(_update_status_list, { ItemId: t.id })
                if (_update_status_list && data.state != "approved") {
                  if (this.all_role_users.length > 0) {
                    let _rn_data = []
                    _.each(this.all_role_users, (d) => {
                      if (d.role_code == _ap_list.Approver) {
                        _rn_data.push(d.username)
                      } else {
                        t.CustomerTempCreditApprover = _ap_list.Approver
                      }
                    })
                    if (_rn_data && _rn_data.length > 0) {
                      t.CustomerTempCreditApprover = _rn_data.join("，")
                    }
                  }
                } else {
                  t.CustomerTempCreditApprover = ""
                }
              })
              this.msgToasts(this.$t("notify.action_successfully"), "success")
              cb(true)
            } else {
              this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
              cb(false)
            }
          }
        })
      }
    },
    //#endregion
    ///信用额度待我审批
    async myApproveChange() {
      this.isAll = false
      let _role_code = ""
      let _username = this.$global.global_data.local_username
      if (this.onlyMyApproved) {
        if (this.$refs.creditTable.my_data.length == 0) {
          this.onlyMyApproved = false
          this.msgToasts(this.$t("notify.not_data"), "info")
          return
        }
        let _result = await api.query_async({
          url: apiPath.user.profile,
          parameters: null,
          method: "get",
        })
        if (
          _result &&
          !_.isNull(_result) &&
          _result[0] &&
          _result[0].result &&
          _result[0].result.data &&
          _result[0].result.data.Result
        ) {
          _role_code = _result[0].result.data.Result.roles[0].code
        }
        let _list = []
        _.each(this.$refs.creditTable.my_data, (t) => {
          if (
            !_.isNull(t.fcGetCustomerCreditApprover) &&
            t.fcGetCustomerCreditApprover
          ) {
            let name_or_role = t.fcGetCustomerCreditApprover.split(",")[0]
            let _is_role = t.fcGetCustomerCreditApprover.split(",")[1]
            if (_is_role == 1) {
              if (name_or_role == _role_code) {
                let _index = _.findIndex(_list, { id: t.id })
                if (_index < 0) {
                  _list.push(t)
                }
              }
            } else {
              if (_username == name_or_role) {
                let _index = _.findIndex(_list, { id: t.id })
                if (_index < 0) {
                  _list.push(t)
                }
              }
            }
          }
        })
        this.$refs.creditTable.SetData(_.orderBy(_list, ["id"], ["desc"]))
      } else {
        let _list = _.filter(this.his_credit_list, function (t) {
          return t.credit_Id != ""
        })
        this.$refs.creditTable.SetData(_list)
        // this.$refs.creditTable.SetData(this.his_credit_list);
      }
    },
    async myTempApproveChange() {
      let _role_code = ""
      let _username = this.$global.global_data.local_username
      if (this.onlyMyTempApproved) {
        if (this.$refs.TempCreditTable.my_data.length == 0) {
          this.onlyMyApproved = false
          this.msgToasts(this.$t("notify.not_selected_data"), "info")
          return
        }
        let _result = await api.query_async({
          url: apiPath.user.profile,
          parameters: null,
          method: "get",
        })
        if (
          _result &&
          !_.isNull(_result) &&
          _result[0] &&
          _result[0].result &&
          _result[0].result.data &&
          _result[0].result.data.Result
        ) {
          _role_code = _result[0].result.data.Result.roles[0].code
        }
        let _list = []
        _.each(this.$refs.TempCreditTable.my_data, (t) => {
          if (
            !_.isNull(t.fcGetCustomerTempCreditApprover) &&
            t.fcGetCustomerTempCreditApprover
          ) {
            let name_or_role = t.fcGetCustomerTempCreditApprover.split(",")[0]
            let _is_role = t.fcGetCustomerTempCreditApprover.split(",")[1]
            if (_is_role == 1) {
              if (name_or_role == _role_code) {
                let _index = _.findIndex(_list, { id: t.id })
                if (_index < 0) {
                  _list.push(t)
                }
              }
            } else {
              if (_username == name_or_role) {
                let _index = _.findIndex(_list, { id: t.id })
                if (_index < 0) {
                  _list.push(t)
                }
              }
            }
          }
        })
        this.$refs.TempCreditTable.SetData(_.orderBy(_list, ["id"], ["desc"]))
      } else {
        this.$refs.TempCreditTable.SetData(this.his_temp_credit_list)
      }
    },
  },
}
</script>
<style>
.hb_table_cust_credit_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 90rem;
}
</style>
